import { createSelector } from 'reselect'

import { getArgN } from './utils'
import * as ProcessSelector from './process'

import { fromID } from './dataset'

export const get = createSelector([ getArgN(1) ], (sampleID) => {
  if (!sampleID) return
  return fromID(sampleID, 'sample')
})

export const getForProcess = createSelector([ ProcessSelector.get ], (process) => {
  if (!process) return
  if (!process.sampleID) return
  return fromID(process.sampleID, 'sample')
})



// WEBPACK FOOTER //
// ../webmango-core/selectors/sample.js